import {
  AssociationGroupsResponse,
  AssociationGroupsSummaryResponse,
  GetAssociationGroupsParams
} from 'api/dtos/associations';
import bounceApiClient from 'legacy/common/utils/bounceApiClient';
import { getAssociationFeed } from './feed';

export const associationsService = {
  /**
   * Get association groups
   * - Uses /api endpoint for authenticated requests (includes userMembership)
   * - Uses /service endpoint for unauthenticated requests (no userMembership)
   */
  getAssociationGroups: async (
    params: GetAssociationGroupsParams & {
      useUnauthenticatedEndpoint?: boolean;
    }
  ): Promise<AssociationGroupsResponse> => {
    const {
      associationId,
      useUnauthenticatedEndpoint = false,
      ...queryParams
    } = params;

    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([_, value]) => value !== undefined)
    );

    const endpoint = useUnauthenticatedEndpoint
      ? `/service/associations/${associationId}/groups`
      : `/api/associations/${associationId}/groups`;

    const response = await bounceApiClient.get(endpoint, {
      params: cleanParams
    });

    return response.data;
  },

  getAssociationFeed,

  exportAssociationMembersCSV: async (associationId: string): Promise<Blob> => {
    const { data } = await bounceApiClient.get(
      `/api/associations/${associationId}/members/export`,
      { responseType: 'blob' }
    );
    return data;
  },

  exportAssociationAffiliatesCSV: async (
    associationId: string
  ): Promise<Blob> => {
    const { data } = await bounceApiClient.get(
      `/api/associations/${associationId}/affiliated-members/export`,
      { responseType: 'blob' }
    );
    return data;
  },

  /**
   * Get lightweight summary of all organizations in an association.
   * Used for the organization allowlist selector in admin settings.
   */
  getAssociationGroupsSummary: async (
    associationId: string
  ): Promise<AssociationGroupsSummaryResponse> => {
    const { data } = await bounceApiClient.get(
      `/api/associations/${associationId}/groups/summary`
    );
    return data;
  }
};
